import EnPNG from './img/en.png'
import EsPNG from './img/spain.png'
import PtPNG from './img/pt.png'

interface LangOptions {
  lang: string
  icon: string
  text: string
  isArabic?: boolean
}

export type languagesType = 'en-US' | 'es-ES' | 'pt-BR'

export const languagesForApi: { [key: string]: languagesType } = {
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'pt-BR': 'pt-BR',
}

export const languages: { [key: string]: languagesType } = {
  EN: 'en-US',
  ES: 'es-ES',
  PT: 'pt-BR',
}

export const languagesWithIcons: { [key in languagesType]: LangOptions } = {
  'en-US': { lang: languages.EN, icon: EnPNG, text: 'English' },
  'es-ES': { lang: languages.ES, icon: EsPNG, text: 'Español' },
  'pt-BR': { lang: languages.PT, icon: PtPNG, text: 'Português' },
}

export const shortLanguages: { [key in languagesType]: string } = {
  'en-US': 'en',
  'es-ES': 'es',
  'pt-BR': 'pt',
}

export const transLang: { [key in languagesType]: string } = {
  'en-US': 'en-US',
  'es-ES': 'es-ES',
  'pt-BR': 'pt-BR',
}

export const languagesForHTML: { [key in languagesType]: string } = {
  'en-US': 'en',
  'es-ES': 'es',
  'pt-BR': 'pt',
}

export const defaultLanguage: languagesType = languages.ES
